<template>
  <header>
    <span v-for="(item,index) in pTitleArr" :key="index" :class="{'title':true,'active':tab === index}" @click="onChangeTab(index)">{{item}}</span>
  </header>
</template>
<script>
import nameMixin from './nameMixin'
export default {
  mixins: [nameMixin],
  props: {
    tab: {
      type: [Number, String],
      default: 0,
    },
  },
  methods: {
    onChangeTab(tabIndex) {
      this.$emit('on-change-tab', tabIndex)
    },
  },
}
</script>

<style lang='stylus'scoped>

span {
  cursor: pointer;
}

.title {
  font-size: 18px;
  color: #999999;
  position: relative;
  margin-right: 20px;

  //&:first-child {
  //  margin-right: 0;
  //}

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: #336db0;

  &::after {
    background: #336db0;
  }
}
</style>
